import AboutSection from '../../sections/AboutSection';
import VisorSection from '../../sections/VisorSection';
import BitacoraSection from '../../sections/BitacoraSection';
import FasesSection from '../../sections/FasesSection';
import Gallery from '../../sections/Gallery';
import Descargas from '../../components/Descargas';
import Hero from '../../components/Hero';
import { motion,AnimatePresence} from "framer-motion";
import { FaFilePdf, FaProjectDiagram, FaLightbulb, FaClipboardList, FaMap } from "react-icons/fa";
import {DocumentRepository2} from '../../components/DocumentRepository';


import './SierradelTigre.css';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  Home as HomeIcon,
  MapPin as MapPinIcon,
  FileText as FileTextIcon,
  Phone as PhoneIcon,
  ChevronDown,
  ChevronRight,
  Menu,
  X,
  ExternalLink,
  Subtitles,
  Users,
  Map,
  Landmark,
  Calendar,MapPin,Info, MountainSnow, Tree,TreePineIcon, ClockIcon,Book,BookOpen,FileSearch,Layers,Target,FileText,File,FileIcon,Download,DownloadIcon,Document,DocumentIcon,
  CheckIcon,FilePdf,FilePdfIcon,ProjectDiagram,ProjectDiagramIcon,Lightbulb,LightbulbIcon,ClipboardList,ClipboardListIcon,CheckCircle,CheckCircleIcon,
  Compass,GlobeIcon,DownloadCloud,DownloadCloudIcon,FileArchive,FileArchiveIcon,Folder,FolderIcon,FolderOpen,FolderOpenIcon,Link,LinkIcon,ExternalLinkIcon,
  ArrowDown,LayersIcon,FileSignature,Zap,FileSpreadsheet,BarChart3
} from 'lucide-react';


const ModernBitacoraSection = ({ items }) => {
  const [expandedSection, setExpandedSection] = useState(0);

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Bitácora del Programa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Registro documental completo del proceso de ordenamiento ecológico
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.button
                key={index}
                onClick={() => setExpandedSection(expandedSection === index ? null : index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`p-6 rounded-2xl transition-all duration-300 text-left ${
                  expandedSection === index
                    ? `bg-gradient-to-br ${item.color} text-white shadow-2xl`
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 shadow-lg hover:shadow-xl'
                }`}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className={`p-3 rounded-xl ${
                    expandedSection === index
                      ? 'bg-white/20'
                      : `bg-gradient-to-br ${item.color}`
                  }`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-semibold">{item.title}</h3>
                </div>
                <p className={`text-sm ${
                  expandedSection === index ? 'text-white/90' : 'text-gray-500 dark:text-gray-400'
                }`}>
                  {expandedSection === index ? 'Ver documentos ↓' : 'Ver documentos →'}
                </p>
              </motion.button>
            );
          })}
        </div>

        {/* Contenido expandido */}
        <AnimatePresence>
          {expandedSection !== null && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700">
                {items[expandedSection].content.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="mb-8 last:mb-0">
                    <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 flex items-center">
                      <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full mr-3" />
                      {section.subtitle}
                    </h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      {section.items.map((doc, docIndex) => (
                        <a
                          key={docIndex}
                          href={doc.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-teal-50 
                            dark:hover:from-blue-900/20 dark:hover:to-teal-900/20 transition-all duration-300"
                        >
                          <div className="flex items-center gap-3">
                            <FileText className="w-5 h-5 text-blue-500 group-hover:text-teal-500 transition-colors" />
                            <span className="text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white">
                              {doc.text}
                            </span>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
                
                <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                  <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
                    {items[expandedSection].content.reduce((total, section) => total + section.items.length, 0)} documentos disponibles
                  </p>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};
const FullWidthVisorWithSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('uga');

  return (
    <section id="visor-completo" className="py-16">
      <div className="max-w-[2000px] mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Plataforma Geoespacial Completa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Sistema de información geográfica integrado con documentación técnica completa
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar - Ancho fijo */}
          <motion.div
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            className={`lg:w-96 ${sidebarOpen ? 'block' : 'hidden lg:block'}`}
          >
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-xl border border-gray-100 dark:border-gray-700 sticky top-6">
              {/* Botón toggle para móviles */}
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden mb-4 w-full p-2 bg-gradient-to-r from-blue-500 to-teal-500 
                  text-white rounded-lg flex items-center justify-center gap-2"
              >
                {sidebarOpen ? 'Ocultar Panel' : 'Mostrar Panel'}
                <ChevronRight className={`w-4 h-4 transition-transform ${sidebarOpen ? 'rotate-90' : ''}`} />
              </button>

              {/* Tabs de navegación */}
              <div className="flex mb-6 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
                <button
                  onClick={() => setActiveTab('uga')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'uga'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Clasificación UGA
                </button>
                <button
                  onClick={() => setActiveTab('descripcion')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'descripcion'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Descripción UGA
                </button>
                <button
                  onClick={() => setActiveTab('politica')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'politica'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Política Ambiental
                </button>
              </div>

              {/* Contenido según tab activo */}
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTab}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="space-y-6"
                >
                  {activeTab === 'uga' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <LayersIcon className="w-5 h-5 text-blue-500 mr-2" />
                          Clasificación de UGAs
                        </h3>
                        <img
                          src="/images/Clave_UGA_Cuenca_Baja_del_Río_Verde.png"
                          alt="Clasificación de Unidades de Gestión Ambiental"
                          className="w-full h-auto rounded-lg shadow-md mb-4"
                        />
                        <p className="text-sm text-gray-600 dark:text-gray-300">
                          Mapa de clasificación de las Unidades de Gestión Ambiental (UGAs) 
                          de la región Sierra Occidental.
                        </p>
                      </div>
                      
                      <div className="bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20 
                        rounded-lg p-4">
                        <h4 className="font-medium text-gray-900 dark:text-white mb-2">Leyenda de UGAs</h4>
                        <ul className="space-y-2 text-sm text-gray-600 dark:text-gray-300">
                          <li className="flex items-center">
                            <div className="w-3 h-3 bg-green-500 rounded mr-2" />
                            UGA de Conservación
                          </li>
                          <li className="flex items-center">
                            <div className="w-3 h-3 bg-yellow-500 rounded mr-2" />
                            UGA de Aprovechamiento Sustentable
                          </li>
                          <li className="flex items-center">
                            <div className="w-3 h-3 bg-orange-500 rounded mr-2" />
                            UGA de Restauración
                          </li>
                          <li className="flex items-center">
                            <div className="w-3 h-3 bg-red-500 rounded mr-2" />
                            UGA de Protección Especial
                          </li>
                          <li className="flex items-center">
                            <div className="w-3 h-3 bg-blue-500 rounded mr-2" />
                            UGA Urbana
                          </li>
                        </ul>
                      </div>
                    </>
                  )}

                  {activeTab === 'descripcion' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Info className="w-5 h-5 text-teal-500 mr-2" />
                          Descripción de las UGAs
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4">
                          Las <strong>Unidades de Gestión Ambiental (UGAs)</strong> son la unidad mínima 
                          del territorio a la que se asignan determinados lineamientos y estrategias 
                          ecológicas para su manejo específico.
                        </p>
                        
                        <div className="space-y-4">
                          <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 
                            rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Características</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Unidad territorial homogénea</li>
                              <li>• Criterios específicos de manejo</li>
                              <li>• Estrategias ecológicas definidas</li>
                              <li>• Monitoreo individualizado</li>
                            </ul>
                          </div>
                          
                          <div className="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 
                            rounded-lg p-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-2">Objetivos</h4>
                            <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                              <li>• Gestión ambiental específica</li>
                              <li>• Aplicación de lineamientos</li>
                              <li>• Evaluación de resultados</li>
                              <li>• Adaptación de estrategias</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {activeTab === 'politica' && (
                    <>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                          <Target className="w-5 h-5 text-purple-500 mr-2" />
                          Política Ambiental
                        </h3>
                        <p className="text-gray-600 dark:text-gray-300 mb-4">
                          El presente <strong>Modelo de Ordenamiento Ecológico y Territorial Regional</strong> 
                          considera una zonificación integrada por cinco políticas que buscan definir 
                          el estado deseable del territorio.
                        </p>
                        
                        <div className="space-y-4">
                          <div className="border-l-4 border-blue-500 pl-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">Conservación</h4>
                            <p className="text-sm text-gray-600 dark:text-gray-300">
                              Protección de ecosistemas y biodiversidad
                            </p>
                          </div>
                          
                          <div className="border-l-4 border-green-500 pl-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">Aprovechamiento Sustentable</h4>
                            <p className="text-sm text-gray-600 dark:text-gray-300">
                              Uso racional de recursos naturales
                            </p>
                          </div>
                          
                          <div className="border-l-4 border-orange-500 pl-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">Restauración</h4>
                            <p className="text-sm text-gray-600 dark:text-gray-300">
                              Recuperación de áreas degradadas
                            </p>
                          </div>
                          
                          <div className="border-l-4 border-red-500 pl-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">Protección</h4>
                            <p className="text-sm text-gray-600 dark:text-gray-300">
                              Salvaguarda de áreas críticas
                            </p>
                          </div>
                          
                          <div className="border-l-4 border-indigo-500 pl-4">
                            <h4 className="font-medium text-gray-900 dark:text-white mb-1">Desarrollo Urbano</h4>
                            <p className="text-sm text-gray-600 dark:text-gray-300">
                              Crecimiento ordenado de asentamientos
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </motion.div>
              </AnimatePresence>

              {/* Botones de acción */}
              <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                <div className="grid grid-cols-2 gap-3">
                  <a
                    href="https://siga.jalisco.gob.mx/ordenamiento/visores/visorsierraoccidental/index.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2.5 bg-gradient-to-r from-blue-500 to-teal-500 text-white 
                      rounded-lg text-sm font-medium text-center hover:shadow-lg transition-all"
                  >
                    <ExternalLink className="w-4 h-4 inline mr-1" />
                    Abrir en Nueva Ventana
                  </a>
                  {/* <button className="px-4 py-2.5 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 
                    rounded-lg text-sm font-medium hover:bg-gray-200 dark:hover:bg-gray-600 transition-all">
                    <Download className="w-4 h-4 inline mr-1" />
                    Descargar Capas
                  </button> */}
                </div>
              </div>
            </div>
          </motion.div>

          {/* Visor - Ocupa el resto del espacio */}
          <div className="flex-1">
            <div className="bg-gray-900 rounded-2xl overflow-hidden shadow-2xl">
              <div className="p-4 bg-gradient-to-r from-gray-800 to-gray-900 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-teal-500 rounded-lg">
                    <GlobeIcon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Visor GIS Sierra Occidental</h3>
                    <p className="text-sm text-gray-400">Sistema interactivo de información geográfica</p>
                  </div>
                </div>
                
                {/* Controles del visor */}
                {/* <div className="flex items-center gap-2">
                  <button className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-white transition-colors">
                    <ZoomInIcon className="w-5 h-5" />
                  </button>
                  <button className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-white transition-colors">
                    <ZoomOutIcon className="w-5 h-5" />
                  </button>
                  <button className="p-2 bg-gradient-to-r from-blue-500 to-teal-500 hover:from-blue-600 hover:to-teal-600 
                    rounded-lg text-white transition-all">
                    <Maximize className="w-5 h-5" />
                  </button>
                </div> */}
              </div>
              
              <div className="h-[600px]">
                <iframe
                  src="https://siga.jalisco.gob.mx/ordenamiento/visores/visorsierraoccidental/index.html"
                  className="w-full h-full border-0"
                  title="Visor GIS Sierra Occidental"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
const StatusBadge = () => {
  return (
    <motion.div 
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500/20 to-teal-500/20 
        backdrop-blur-md border border-emerald-500/30"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse mr-2" />
      <span className="text-sm font-medium text-white tracking-wider">FASE </span>
      <div className="ml-2 pl-2 border-l border-white/20">
        <span className="text-xs text-white/70">Suspendido</span>
      </div>
    </motion.div>
  );
};

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

const DetailBadge = ({ icon: Icon, label, value }) => (
  <div className="flex items-center p-3 bg-gray-50 dark:bg-gray-700 rounded-xl transition-all hover:bg-teal-100 dark:hover:bg-teal-900/30">
    <Icon className="text-teal-600 dark:text-teal-400 mr-3 flex-shrink-0" size={20} />
    <div className="text-sm">
      <span className="font-semibold text-gray-700 dark:text-gray-300 block leading-tight">{label}:</span>
      <span className="text-gray-900 dark:text-white font-bold">{value}</span>
    </div>
  </div>
);

const Items = [
  {
    title: "Archivos Vectoriales",
    description: "Archivos geoespaciales para la consulta SIG.",
    imageUrl: "images/vectoriales.png", // sky-600
    baseColor: "sky",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Vectoriales_Rio_Verde.zip",

    target: "_blank",
  },
  {
    title: "Fichas UGAss",
    description: "Informacion detallada de cada Unidad de Gestión Ambiental (UGA).",
    imageUrl: "images/FICHAS_UGA.png", // green-600
    baseColor: "green",
    
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Cuenca%20Baja%20del%20R%C3%ADo%20Verde.pdf",
    target: "_blank",
  },
  {
    title: "Criterios",
    description: "Regulaciones ecológicas para la preservación y restauración del territorio.",
    imageUrl: "images/Criterios.png", // orange-600
    baseColor: "orange",
    
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Criterios%20de%20regulaci%C3%B3n%20ecol%C3%B3gica%20Regi%C3%B3n%20Cuenca%20Baja%20del%20R%C3%ADo%20Verde.pdf",
    target: "_blank",
  },
  {
    title: "Estrategias Ecologicas",
    description: "Proyectos de orientación para la protección del entorno natural.",
    imageUrl: "images/Estrategias.png", // red-600
    baseColor: "red",
    
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Evaluaci%C3%B3n%20estrat%C3%A9gica%20ambiental%20Regi%C3%B3n%20Cuenca%20Baja%20del%20R%C3%ADo%20Verde.pdf",

    target: "_blank",
  },
  {
    title: "Lineamientos",
    description: "Conservar, proteger y restaurar los recursos naturales de la región.",
    imageUrl: "images/Lineamientos.png", // indigo-600
    baseColor: "indigo",    
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Lineamientos%20ecol%C3%B3gicos%20Regi%C3%B3n%20Cuenca%20Baja%20del%20R%C3%ADo%20Verde.pdf",
    target: "_blank",
  },
  {
    title: "Usos y Actividades",
    description: "Visualiza toda la información SIG directamente en el navegador.",
    imageUrl: "images/Usos_Actividades.png", // teal-600
    baseColor: "teal",
    
    link: "https://siga.jalisco.gob.mx/ordenamiento/mapa/index.html?capa=cuenca_alta_costa_sur",
    target: "_blank",
  },
];

const items = [
  {
    title: "Archivos Vectoriales",
    description: "Formatos editables y mapas en alta calidad.",
    img: <img src="images/vectoriales.png" alt="Archivos Vectoriales" className="w-16 h-16 mb-4" />,
    icon: <FaMap className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Vectoriales_Rio_Verde.zip",
    target: "_blank",
  },
  {
    title: "Fichas",
    description: "Documentos descriptivos y técnicos.",
    img: <img src="images/Fichas_Informativas.png" alt="Fichas" className="w-16 h-16 mb-4" />,
    icon: <FaClipboardList className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Cuenca%20Baja%20del%20R%C3%ADo%20Verde.pdf",
    target: "_blank",
  },
  {
    title: "Criterios",
    description: "Lineamientos técnicos y normativos.",
    img: <img src="images/Criterios.png" alt="Criterios" className="w-16 h-16 mb-4" />,
    icon: <FaFilePdf className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Criterios%20de%20regulaci%C3%B3n%20ecol%C3%B3gica%20Regi%C3%B3n%20Cuenca%20Baja%20del%20R%C3%ADo%20Verde.pdf",
  },
  {
    title: "Estrategias",
    description: "Propuestas y planes de acción.",
    img: <img src="images/Estrategias.png" alt="Estrategias" className="w-16 h-16 mb-4" />,
    icon: <FaProjectDiagram className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Evaluaci%C3%B3n%20estrat%C3%A9gica%20ambiental%20Regi%C3%B3n%20Cuenca%20Baja%20del%20R%C3%ADo%20Verde.pdf",
  },
  {
    title: "Lineamientos",
    description: "Guías de aplicación práctica.",
    img: <img src="images/Lineamientos.png" alt="Lineamientos" className="w-16 h-16 mb-4" />,
    icon: <FaLightbulb className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Lineamientos%20ecol%C3%B3gicos%20Regi%C3%B3n%20Cuenca%20Baja%20del%20R%C3%ADo%20Verde.pdf",
  },
  {
    title: "Usos Y Actividades",
    description: "Sujetos a controles ambientales en la región.",
    img: <img src="images/Lineamientos.png" alt="Lineamientos" className="w-16 h-16 mb-4" />,
    icon: <FaLightbulb className="text-5xl text-white" />,
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Listado%20de%20usos%20y%20actividades%20sujetos%20a%20controles%20ambientales%20Regi%C3%B3n%20Cuenca%20Baja%20del%20R%C3%ADo%20Verde.pdf",
  },
];
const imageList = [
    {
        id: '1',
        src: 'images/cabo-corrientes-escudo.png',
        thumbnail: 'images/cabo-corrientes-escudo.png',
        alt: 'Paisaje con montañas',
        caption: 'Cabo Corrientes.'
    },
    {
        id: '2',
        src: 'images/tomatlan-escudo.png',
        thumbnail: 'images/tomatlan-escudo.png',
        alt: 'Ciudad nocturna',
        caption: 'Tomatlán.'
    },
    {
        id: '3',
        src: 'images/la_huerta-escudo.png',
        thumbnail: 'images/la_huerta-escudo.png',
        alt: 'Bosque en otoño',
        caption: 'La Huerta.'
    },
    {
        id: '4',
        src: 'images/cihuatlan-escudo.png',
        thumbnail: 'images/cihuatlan-escudo.png',
        alt: 'Playa tropical',
        caption: 'Cihuatlán.'
    },
    
];

const municipalities = [
  {
    id: 1,
    name: 'Acatic',
    shield: 'images/RioVerde/escudo_Acatic.png',
    description: 'Con predominio de agricultura de riego y ganadería, se ubica en lomeríos y valles con suelos fértiles y arroyos temporales que aportan al riego agrícola. Sus áreas naturales permiten la observación de especies locales.',
    population: '23,175 habitantes',
    area: '339.2 km²',
    foundation: '1820',
    attractions: 'Entre sus atractivos destacan los paisajes del río Verde, el río Acatic y el río Calderón, además de la presa Lagunillas como punto escénico. El entorno natural resalta en el bosque de Los Alacates, ideal para caminatas y descanso. La zona combina vistas ribereñas, senderos y ambientes arbolados con encinos y robles.',
    color: 'from-blue-500 to-teal-600',
    administrativeRegion: 'Altos Sur',
    EcologicaZona: 'Área Natural Protegida Formación Natural Estatal Barranca De Los Ríos Santiago Y Verde.',
    NumerodeUgas: '5 Unidades de Gestión Ambiental (UGA).',
  },
    {
    id: 2,
    name: 'Cañadas de Obregón',
    shield: 'images/RioVerde/escudo_Cañadas_de_Obregón.png',
    description: 'Dedicado a la agricultura de temporal y ganadería, se encuentra en valles y cañadas con remanentes de pastizales y pequeños bosques de pino–encino. Sus ríos temporales y suelos fértiles favorecen el turismo rural y proyectos comunitario.',
    population: '4,388 habitantes',
    area: '271.8 km²',
    foundation: '1903',
    attractions: 'Destacan los paisajes del río Verde y los arroyos como El Salto. En Temacapulín se encuentran balnearios y manantiales de aguas termales. Sobresalen los bosques de El Pandito, Potrerillos y El Laurel, ideales para recorridos naturales, además de templos y construcciones religiosas del siglo XVIII que enriquecen el atractivo histórico.',
    color: 'from-amber-500 to-orange-600',
    administrativeRegion: 'Altos Sur',
    EcologicaZona: 'Área Natural Protegida Zona de Restauración Ecológica Presa el Zapotillo.',
    NumerodeUgas: '5 Unidades de Gestión Ambiental (UGA).',
  },
  {
    id: 3,
    name: '',
    shield: 'images/RioVerde/escudo_Cuquío.png',
    description: 'Reconocido por su agricultura y ganadería, el municipio se desarrolla en lomeríos y cañadas con bosques de pino–encino y ríos temporales que atraviesan el territorio. Este entorno permite actividades de ecoturismo y programas de protección.',
    population: '17,820 habitantes',
    area: '643 km²',
    foundation: '1824',
    attractions: 'Sobresalen los paisajes del río Verde y el arroyo permanente Atenguillo, ideales para recorridos naturales. Las zonas boscosas de La Silleta y Plan de Potrerillos ofrecen amplias vistas y senderos entre encinos y pinos. También destaca una zona arqueológica y construcciones coloniales que complementan el atractivo histórico y cultural del lugar.',
    color: 'from-green-500 to-emerald-600',
    administrativeRegion: 'Centro',
    EcologicaZona: 'Área Natural Protegida Formación Natural Estatal Barranca De Los Ríos Santiago Y Verde.',
    NumerodeUgas: '9 Unidades de Gestión Ambiental (UGA).',
  },

  {
    id: 4,
    name: 'Jalostotitlán',
    shield: 'images/RioVerde/escudo_Jalostotitlán.png',
    description: 'Con agricultura y ganadería como principales actividades, el municipio se localiza en llanuras y lomeríos con pastizales naturales y suelos fértiles. Su paisaje facilita la implementación de técnicas de conservación de agua y suelo.',
    population: '32,678 habitantes',
    area: '520.9 km²',
    foundation: '1824',
    attractions: 'Destacan los paisajes del río Jalostotitlán y otros cauces como San Gaspar y La Laja, ideales para recorridos al aire libre. También sobresale la laguna de Jalostotitlán como punto escénico. En el ámbito cultural, resaltan los vestigios arqueológicos de Teocaltitán y templos históricos que enriquecen la visita.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Altos Sur',
    EcologicaZona: 'Área Natural Protegida Zona de Restauración Ecológica Presa el Zapotillo.',
    NumerodeUgas: '8 Unidades de Gestión Ambiental (UGA).',
  },
  {
    id: 5,
    name: 'Mexticacán',
    shield: 'images/RioVerde/escudo_Mexticacán.png',
    description: 'Dedicado a la agricultura de temporal y ganadería, el municipio se asienta en valles con ríos intermitentes y vegetación ribereña. Estas características permiten la práctica de ecoturismo rural y la aplicación de estrategias de manejo sostenible.',
    population: '5,307 habitantes',
    area: '287 km²',
    foundation: '1837',
    attractions: 'Destacan los paisajes del río Verde y otros cauces como Ipalco, Ancho y Yahualica, acompañados por arroyos permanentes y temporales que enriquecen el entorno. La zona presenta áreas boscosas con cedro, sabino, álamo y mezquite. En el ámbito histórico sobresalen la Parroquia de San Nicolás, la Capilla de Guadalupe y el Santuario del Sagrado Corazón.',
    color: 'from-green-500 to-indigo-600',
    administrativeRegion: 'Altos Sur',
    EcologicaZona: 'Área Natural Protegida Zona de Restauración Ecológica Presa el Zapotillo.',
    NumerodeUgas: '4 Unidades de Gestión Ambiental (UGA).',
  },
  {
    id: 6,
    name: 'San Julián',
    shield: 'images/RioVerde/escudo_San_Julián.png',
    description: 'Con predominio de agricultura y ganadería, se localiza en lomeríos y valles con suelos fértiles y arroyos estacionales. Su entorno natural favorece la observación de flora y fauna, así como programas de conservación.',
    population: '16,792 habitantes',
    area: '261.9 km²',
    foundation: '1912',
    attractions: 'San Julián destaca por sus entornos naturales, como la presa San Isidro y áreas arboladas perfectas para el esparcimiento. Sobresalen espacios como El Santo Cristo, el cerro El Tolimán con su monumento a Cristo Rey y la barranca de Sánchez. En lo histórico resaltan la Parroquia de San José Obrero, el portal de Iturbide y la plaza principal.',
    color: 'from-blue-800 to-blue-900',
    administrativeRegion: 'Altos Sur',
    EcologicaZona: '',
    NumerodeUgas: '3 Unidades de Gestión Ambiental (UGA).',
  },
  {
    id: 7,
    name: 'San Miguel el Alto',
    
    shield: 'images/RioVerde/escudo_San_Miguel_el_Alto.png',
    description: 'Sustentado en agricultura y ganadería, se encuentra en lomeríos y valles con suelos fértiles y fragmentos de bosque de pino–encino. Sus áreas naturales permiten la práctica de ecoturismo y fomentan la conservación.',
    population: '31,965 habitantes',
    area: '787 km²',
    foundation: '1824',
    attractions: 'San Miguel el Alto resalta por sus extensos paisajes naturales, como La Mesa, el Cerro de Cristo Rey y el Cerro del Caracol. También destacan sitios como el Salto del Gavilán, la Presa San Miguel y las ruinas del rancho del Pochotl, ideales para recorridos escénicos y recreación al aire libre.',
    color: 'from-purple-800 to-indigo-600',
    administrativeRegion: 'Altos Sur',
    EcologicaZona: '',
    NumerodeUgas: '9 Unidades de Gestión Ambiental (UGA).',
  },
  {
    id: 8,
    name: 'Tepatitlán de Morelos',
    
    shield: 'images/RioVerde/escudo_Tepatitlán_de_Morelos.png',
    description: 'Destacado por su agricultura y ganadería, se ubica en valles con suelos fértiles y pequeñas corrientes fluviales que permiten el riego y el mantenimiento de pastizales. Estas áreas favorecen el ecoturismo rural.',
    population: '150,190 habitantes',
    area: '1,400.1 km²',
    foundation: '1824',
    attractions: 'Tepatitlán de Morelos destaca por su centro histórico con una elegante plaza cívica y kiosco, el Palacio Municipal y templos como el Santuario del Señor de la Misericordia. Entre sus atractivos también figuran el Lienzo Charro y la Ex Hacienda de Calaca, además de paisajes forestales ideales para el esparcimiento.',
    color: 'from-purple-800 to-indigo-600',
    administrativeRegion: 'Altos Sur',
    EcologicaZona: 'Área Natural Protegida Formación Natural Estatal Barranca De Los Ríos Santiago Y Verde.',
    NumerodeUgas: '15 Unidades de Gestión Ambiental (UGA).',
  },
  {
    id: 9,
    name: 'Valle de Guadalupe',
    
    shield: 'images/RioVerde/escudo_Valle_de_Guadalupe.png',
    description: 'Con actividades agrícolas y ganaderas, se encuentra en valles y lomeríos con vegetación ribereña y suelos fértiles para cultivos. Su entorno natural favorece la observación de fauna local y la ejecución de programas de manejo sostenible.',
    population: '6,627 habitantes',
    area: '352.3 km²',
    foundation: '1922',
    attractions: 'Sobresalen los escenarios naturales, especialmente El Salto de Agua y la zona boscosa conocida como El Charco del Mar, espacios que ofrecen un entorno tranquilo y vistas atractivas. La presencia de ríos, arroyos y áreas arboladas refuerza el valor ecológico del lugar, convirtiéndolo en un punto ideal para disfrutar del paisaje.',
    color: 'from-purple-800 to-indigo-600',
    administrativeRegion: 'Altos Sur',
    EcologicaZona: '',
    NumerodeUgas: '9 Unidades de Gestión Ambiental (UGA).',
  },
  {
    id: 10,
    name: 'Yahualica de Gonzalez Gallo',
    
    shield: 'images/RioVerde/escudo_Yahualica_de_Gonzalez_Gallo.png',
    description: 'Dedicado a la agricultura de riego y ganadería, se desarrolla en llanuras y valles atravesados por ríos temporales y pastizales. Sus ecosistemas permiten el turismo rural y la implementación de prácticas locales de conservación.',
    population: '22,394 habitantes',
    area: '563.3 km²',
    foundation: '1878',
    attractions: 'Bosques extensos y paisajes del cerro de Los Negros, junto con ríos, arroyos y la presa El Estribón, destacan como atractivos naturales ideales para recorridos y pesca. Se complementan con construcciones históricas como la Parroquia de San Miguel Arcángel y la plaza principal.',
    color: 'from-purple-800 to-indigo-600',
    administrativeRegion: 'Altos Sur',
    EcologicaZona: 'Área Natural Protegida Zona de Restauración Ecológica Presa el Zapotillo.',
    NumerodeUgas: '8 Unidades de Gestión Ambiental (UGA).',
  },
];


const SierradelTigre = () => {
  const [selectedMunicipality, setSelectedMunicipality] = useState(municipalities[0]);
  const aboutContent = `

  <h2 class="text-2xl font-bold mb-4">Ordenamiento Región Cuenca Río Verde</h2>

    <p class="  text-justify" >El Gobierno del Estado de Jalisco impulsa el desarrollo sustentable en la región denominada Rio Verde, integrada por los municipios de Acatic, Cuquío, Cañadas de Obregón, Jalostotitlán, Mexticacán, San Julián, San Miguel el Alto, Tepatitlán de Morelos, Valle de Guadalupe y Yahualica de Gonzalez Gallo.  Para impulsar dicho desarrollo, el día 15 de mayo del 2023 el Gobierno del Estado de Jalisco y los municipios firmaron un Convenio de Coordinación que garantiza la realización de las actividades programadas. Se trata de una colaboración que involucra por igual a los diferentes órdenes de gobierno: Estado y Municipios. El objeto del convenio consistió en establecer las bases para el proceso destinado a la elaboración del ordenamiento territorial. 

</p>
<p class=" text-justify"> Asimismo, se firmó con la Federación un Convenio Marco de Coordinación junto con SEMARNAT Y SEDATU de fecha el 27 de enero de 2020.  Estos convenios establecen los fundamentos para la colaboración en el proceso de elaboración de los siguientes instrumentos de ordenamiento territorial.</p>
<p class=" text-justify " > Derivado de esto se inició con el proceso de elaboración de los instrumentos, seguido por el proceso de consulta, la cual incluyó amplia participación de los sectores que influyen en el territorio. Las fechas más relevantes sobre el proceso de elaboración se describen a continuación:

    </p>
    <br>
    
  `;

  const aboutLinks = [
    
    { text: 'Programa de Ordenamiento Ecológico y Territorial Regional', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Rio%20verde.pdf' },
    { text: 'Plan Regional de Integración Urbana', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Plan%20Regional%20de%20Integraci%C3%B3n%20Urbana%20Regi%C3%B3n%20Rio%20verde.pdf' },
    { text: 'Programas Municipales de Desarrollo Urbano (Ver en Inicio)', url: '/descargas/Zula' },
    
  ];

  const aboutDates = [
    { label: 'Inicio de proceso de formulación', date: '27/09/2022' },
    { label: 'Inicio de consulta Pública', date: '22/06/2023' },
    { label: 'Fin de consulta Pública', date: '22/08/2023' },
    { label: 'Sesión de validación', date: '26/01/2024' },
    { label: 'Fecha Publicación', date: '28/09/2024' },
  ];
  
  const bitacoraItems = [
  {
    title: 'FASE DE FORMULACIÓN',
    icon: FileSignature,
    color: 'from-blue-500 to-cyan-500',
    content: [
      {
        subtitle: 'Acuerdos de Integración Municipal',
        items: [
          { text: 'Acuerdo de integración - Atenguillo', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Inicio/Acuerdo%20de%20integraci%C3%B3n%20-%20Atenguillo.pdf' },
          { text: 'Acuerdo de integración - Guachinango', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Inicio/Acuerdo%20de%20integraci%C3%B3n%20-%20Guachinango.pdf' },
          { text: 'Acuerdo de integración - Mascota', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Inicio/Acuerdo%20de%20integraci%C3%B3n%20-%20Mascota.pdf' },
          { text: 'Acuerdo de integración - Mixtlán', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Inicio/Acuerdo%20de%20integraci%C3%B3n%20-%20Mixtl%C3%A1n.pdf' },
          { text: 'Acuerdo de integración - San Sebastian del Oeste', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Inicio/Acuerdo%20de%20integraci%C3%B3n%20-%20San%20Sebastian%20del%20Oeste.PDF' }
        ]
      },
      {
        subtitle: 'Actas de Aprobación',
        items: [
          { text: 'Acta de aprobación - Atenguillo POETR Y PMDU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Aprobacion/Acta%20de%20aprobaci%C3%B3n%20-%20Atenguillo%20POETR%20Y%20PMDU.pdf' },
          { text: 'Acta de aprobación - Guachinango POETR Y PMDU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Aprobacion/Acta%20de%20aprobaci%C3%B3n%20-%20Guachinango%20POETR%20Y%20PMDU.pdf' },
          { text: 'Acta de aprobación - Mascota POETR Y PMDU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Aprobacion/Acta%20de%20aprobaci%C3%B3n%20-%20Mascota%20%20POETR%20Y%20PMDU.pdf' },
          { text: 'Acta de aprobación - Mixtlan PMDU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Aprobacion/Acta%20de%20aprobaci%C3%B3n%20-%20Mixtlan%20PMDU.PDF' },
          { text: 'Acta de aprobación - Mixtlan POETR', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Aprobacion/Acta%20de%20aprobaci%C3%B3n%20-%20Mixtlan%20POETR.PDF' },
          { text: 'Acta de aprobación - San Sebastian del Oeste POETR Y PMDU', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Gestion/Aprobacion/Acta%20de%20aprobaci%C3%B3n%20-%20San%20Sebastian%20del%20Oeste%20POETR%20Y%20PMDU.pdf' }
        ]
      },
      {
        subtitle: 'Convenios',
        items: [
          { text: 'Convenio Marco de Coordinación Estado - Federación', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/verde/Convenio/ConvenioMarcoEstado_Federacion.pdf' },
          { text: 'Convenio de Coordinación Estado-Municipios "Región Sierra Occidental"', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Convenio/publicacion_OET_Sierra_Occidental.pdf' }
        ]
      }
    ]
  },
  {
    title: 'FASE DE EXPEDICIÓN',
    icon: FileSpreadsheet,
    color: 'from-emerald-500 to-green-500',
    content: [
      {
        subtitle: 'Participación Ciudadana',
        items: [
          { text: 'Listas de Asistencia Foro taller de Participación Ciudadana', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Elaboracion/01_Listas_de_Asistencia_Foro_taller_de_Participacion_ciudadana.pdf' },
          { text: 'Respuestas a las Observaciones de la Consulta Pública', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Elaboracion/Respuestas_a_las_observaciones_de_la_consulta_publica_RSO.pdf' }
        ]
      },
      {
        subtitle: 'Documentos Técnicos',
        items: [
          { text: 'Programa de Ordenamiento Ecológico Territorial Regional de la Sierra Occidental', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Elaboracion/documentos/' },
          { text: 'Publicación Periódico Oficial del Estado Región Sierra Occidental', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Elaboracion/POERT_Sierra_Occidental_Peri%C3%B3dico.pdf' }
        ]
      }
    ]
  },
  {
    title: 'FASE DE EJECUCIÓN',
    icon: Zap,
    color: 'from-amber-500 to-orange-500',
    content: [
      {
        subtitle: 'Actas del Consejo Regional',
        items: [
          { text: 'Acta de Instalación y Primera Ordinaria', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Consejo/Acta_de_instalacion_1er_ordinaria_CR_SOCC.pdf' },
          { text: 'Lista de asistencia instalación y 1er ordinaria', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Consejo/Lista_Asistencia_instalacion_y_1er_ord_%20CR%20SOCC.pdf' },
          { text: 'Acta Primera Sesión 2023 CR Sierra Occidental', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Consejo/Acta_Primera_Sesion_2023_CR_Sierra_Occidental_Censurado.pdf' },
          { text: 'Acta Segunda Sesión 2023 CR Sierra Occidental', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Consejo/Acta_de_la_Segunda_Sesion_CRSO_Validacion_Censurado.pdf' },
          { text: 'Lista de asistencia Segunda Sesión 2023', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Consejo/Lista_de_Asistencia_CRSO_segunda_sesion_2023_Censurado.pdf' }
        ]
      },
      {
        subtitle: 'Seguimiento y Monitoreo',
        items: [
          { text: 'Boletas Registrales Sierra Occidental', url: '#https://siga.jalisco.gob.mx/ordenamiento/archivos/Occidental/Ejecucion/BOLETAS_REGISTRALES_DE_SIERRA_OCCIDENTAL.pdf' },
          
        ]
      }
    ]
  },
  {
    title: 'FASE DE EVALUACIÓN',
    icon: BarChart3,
    color: 'from-purple-500 to-violet-500',
    content: [
      {
        subtitle: 'Evaluaciones Programadas',
        items: [
          // { text: 'Plan de Evaluación Anual 2025', url: '#' },
          // { text: 'Metodología de Evaluación de Impacto', url: '#' },
          // { text: 'Indicadores de Desempeño Ambiental', url: '#' }
        ]
      },
      {
        subtitle: 'Ajustes y Mejoras',
        items: [
          // { text: 'Protocolo de Ajustes al Programa', url: '#' },
          // { text: 'Propuestas de Mejora Continua', url: '#' },
          // { text: 'Retroalimentación de Usuarios', url: '#' }
        ]
      }
    ]
  }
];
  const bitacoraItems2 = [
    {
      title: 'FASE DE FORMULACIÓN',
      Subtitles: 'Gestión de la Región Rio Verde',
      content: `<ul>
               

    <li style="color:dimgray"><a href="https://siga.jalisco.gob.mx/ordenamiento/archivos/Tigre/Gestion/01.-%20Acta%20de%20aprobaci%C3%B3n%20Valle%20de%20Ju%C3%A1rez.pdf" class="btn-link" target="_blank"> <span style="color: #93D500">01.- Acta de aprobacion Valle de Juárez</span></a></li>
                                        <li style="color:dimgray"><a href="https://siga.jalisco.gob.mx/ordenamiento/archivos/Tigre/Gestion/02.-%20Acta%20de%20aprobaci%C3%B3n%20de%20Tamazula.pdf" class="btn-link" target="_blank"> <span style="color: #93D500">02.- Acta de aprobacion Tamazula de Gordiano</span></a></li>
                                        <li style="color:dimgray"><a href="https://siga.jalisco.gob.mx/ordenamiento/archivos/Tigre/Gestion/03.-%20Acta%20de%20aprobaci%C3%B3n%20Mazamitla.pdf" class="btn-link" target="_blank"> <span style="color: #93D500">03.- Acta de aprobación Mazamitla</span></a></li>
                                        
                                        <li style="color:dimgray"><a href="https://siga.jalisco.gob.mx/ordenamiento/archivos/Tigre/Gestion/04.-%20Acta%20de%20aprobaci%C3%B3n%20La%20Manzanilla.pdf" class="btn-link" target="_blank"> <span style="color: #93D500">04.- Acta de aprobación La Manzanilla</span></a></li>
                                        <li style="color:dimgray"><a href="https://siga.jalisco.gob.mx/ordenamiento/archivos/Tigre/Gestion/05.-%20Acta%20de%20aprobaci%C3%B3n%20Concepci%C3%B3n%20de%20Buenos%20Aires.pdf" class="btn-link" target="_blank"> <span style="color: #93D500">05.- Acta de aprobación Concepción de Buenos Aires</span></a></li>
                                        <li style="color:dimgray"><a href="https://siga.jalisco.gob.mx/ordenamiento/archivos/Tigre/Gestion/06.-%20Acta%20de%20aprobaci%C3%B3n%20Quitupan.pdf" class="btn-link" target="_blank"> <span style="color: #93D500">06.- Acta de aprobación Quitupan</span></a></li>
                                        <li style="color:dimgray"><a href="https://siga.jalisco.gob.mx/ordenamiento/archivos/Tigre/Gestion/Reporte%20Siera%20del%20Tigre.docx" class="btn-link" target="_blank"> <span style="color: #93D500"> 07,- Comunicado de la suspensión del Programa de Ordenamiento Ecológico y Territorial Regional (POETR), así como el Plan Regional de Integración Urbana (PRIU) y los Programas Municipales de Desarrollo Urbano (PMDU) de la Región "Sierra del Tigre" </span></a></li>
                                        

                                    


 </ul>`
    },
    {
      title: 'FASE DE EXPEDICIÓN',
      content: `<ul>
          


        </ul>`
    },
    {
      title: 'FASE DE EJECUCIÓN',
      content: `<ul>
         
        </ul>`
    },
    {
      title: 'FASE DE EVALUACIÓN',
      content: `<ul>
        
       
       
                                   




        </ul>`
    },

    // ... otros items de bitácora
  ];
  const RioVerdeMain = [
  {id: 0, title: "Publicación en  Periódico Oficial", subtitle: "Versión completa", icon: <Book className="w-5 h-5 text-green-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Rio%20verde.pdf"
   },
    { id: 1, title: "POETR Río Verde", subtitle: "Versión abreviada", icon: <Map className="w-5 h-5 text-emerald-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Rio%20verde.pdf"
     },
    { id: 2, title: "A. Guía de lectura", subtitle: "Introducción", icon: <BookOpen className="w-5 h-5 text-blue-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/A._Guia_de_Lectura_Introduccion.pdf"
     },
    { id: 3, title: "B. Bases técnicas", subtitle: "Metodología", icon: <FileSearch className="w-5 h-5 text-purple-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/B._Bases_técnicas.pdf"
     },
    { id: 4, title: "C. Estructura POETR", subtitle: "Contenido detallado", icon: <Layers className="w-5 h-5 text-amber-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/C. Programa de Ordenamiento Ecológico Regional.cleaned.pdf"
     },
    { id: 5, title: "D. Plan Integración Urbana", subtitle: "Desarrollo Regional", icon: <Target className="w-5 h-5 text-rose-400" />,
    url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Plan%20Regional%20de%20Integraci%C3%B3n%20Urbana%20Regi%C3%B3n%20Rio%20verde.pdf"
     },
{ id: '6.1', title: "Proyectos estratégicos", category: "Anexos", url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Anexo 3. Proyectos estrategicos.pdf" },
    { id: '6.2', title: "Indicadores", category: "Anexos", url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Anexo 7. Indicadores.pdf" },
    { id: '6.3', title: "Apéndice técnico", category: "Anexos", url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Anexo 8. Apendice tecnico.pdf" },
    { id: '6.4', title: "Agenda territorial", category: "Anexos", url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Anexo 9. Agenda territorial.pdf" }
  ];
  const ModernBanner = ({ onScrollClick }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  
  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      setMousePosition({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const stats = [
    { value: "10", label: "Municipios", icon: MapPin },
    { value: "15,842", label: "km²", icon: Map },
    { value: "2022", label: "Inicio", icon: Calendar },
    { value: "Vigente", label: "Estado", icon: CheckCircle },
  ];

  return (
    <>
      {/* Banner Principal con fondo más claro */}
      <section className="relative h-screen min-h-[800px] overflow-hidden">
        {/* Fondo con overlay más claro */}
        <div className="absolute inset-0">
          <img
            src="images/Sierra_del_Tigre.jpeg"
            alt="Paisaje Cuenca Río Verde"
            className="w-full h-full object-cover"
            style={{
              transform: `translate(${mousePosition.x * 0.01}px, ${mousePosition.y * 0.01}px)`,
              transition: 'transform 0.1s ease-out'
            }}
          />
          
          {/* Overlay MÁS CLARO (reducida opacidad) */}
          <div className="absolute inset-0 bg-gradient-to-br from-gray-900/70 via-gray-900/60 to-gray-900/50" />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/30 via-transparent to-gray-900/10" />
          
          {/* Efectos de luz más sutiles */}
          <div 
            className="absolute top-1/4 left-1/4 w-64 h-64 bg-gradient-to-r from-blue-500/5 to-teal-500/5 rounded-full blur-3xl"
            style={{
              transform: `translate(${mousePosition.x * 0.02}px, ${mousePosition.y * 0.02}px)`
            }}
          />
        </div>

        {/* Contenido */}
        <div className="relative z-10 h-full flex items-center px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto w-full">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Columna izquierda */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="space-y-8"
              >
                {/* Badge */}
                <StatusBadge />

                {/* Título */}
                <div className="space-y-4">
                  <h1 className="text-4xl md:text-5xl font-light text-white leading-tight">
                    Región
                    <br />
                    <span className="font-bold bg-gradient-to-r from-blue-400 via-teal-400 to-emerald-400 
                      bg-clip-text text-transparent">
                      Sierra del Tigre
                    </span>
                  </h1>
                  
                  <div className="flex items-center gap-3 text-white/90">
                    <div className="h-px w-12 bg-gradient-to-r from-blue-400 to-transparent" />
                    <span className="text-lg font-light tracking-wide">
                      Ordenamiento Ecológico Territorial· Regional
                    </span>
                  </div>
                </div>

               
                {/* <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className="text-white/80 text-base leading-relaxed max-w-md font-light"
                >
                  Estrategia integral para la gestión sustentable del territorio, 
                  equilibrando el desarrollo humano con la preservación de los 
                  ecosistemas de la región.
                </motion.p> */}

               
                {/* <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6 }}
                  className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-6 border-t border-white/20"
                >
                  {stats.map((stat, index) => {
                    const Icon = stat.icon;
                    return (
                      <div key={index} className="text-center">
                        <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
                        <div className="text-xs text-white/70 tracking-wide">{stat.label}</div>
                      </div>
                    );
                  })}
                </motion.div> */}
              </motion.div>

              
              {/* <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                className="space-y-6"
              >
               
                <motion.div
                  whileHover={{ scale: 1.02 }}
                  className="bg-white/15 backdrop-blur-md rounded-2xl p-8 border border-white/30"
                >
                  <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 bg-gradient-to-br from-blue-500 to-teal-500 rounded-xl">
                      <Compass className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-white">Explorar Programa</h3>
                      <p className="text-sm text-white/80">Acceso completo a recursos</p>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <button 
                      onClick={() => onScrollClick('DocumentosE')}
                      className="w-full px-6 py-4 bg-gradient-to-r from-blue-600 to-teal-600 
                        text-white rounded-xl hover:shadow-xl transition-all duration-300
                        flex items-center justify-center gap-3 font-medium group"
                    >
                      <FileText className="w-5 h-5" />
                      Documentos Especiales
                      <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </button>
                    
                    <button 
                      onClick={() => onScrollClick('visor-completo')}
                      className="w-full px-6 py-4 bg-white/20 backdrop-blur-md border border-white/30
                        text-white rounded-xl hover:bg-white/30 transition-all duration-300
                        flex items-center justify-center gap-3 font-medium"
                    >
                      <GlobeIcon className="w-5 h-5" />
                      Visor GIS Completo
                    </button>
                    
                    <button 
                      onClick={() => onScrollClick('Descargas')}
                      className="w-full px-6 py-4 bg-white/10 backdrop-blur-md border border-white/20
                        text-white rounded-xl hover:bg-white/20 transition-all duration-300
                        flex items-center justify-center gap-3 font-medium"
                    >
                      <DownloadCloud className="w-5 h-5" />
                      Recursos Especializados
                    </button>
                  </div>
                </motion.div>
              </motion.div> */}
            </div>
          </div>
        </div>

        {/* Indicador de scroll */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        >
          <button 
            onClick={() => onScrollClick('introduccion')}
            className="group flex flex-col items-center"
          >
            <span className="text-xs text-white/80 mb-2 tracking-widest font-light">
              EXPLORAR
            </span>
            <motion.div
              animate={{ y: [0, 8, 0] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
              className="p-2 bg-white/20 backdrop-blur-md rounded-full border border-white/30
                group-hover:bg-white/30 transition-all"
            >
              <ArrowDown className="w-5 h-5 text-white" />
            </motion.div>
          </button>
        </motion.div>
      </section>
    </>
  );
};
  return (
    <div className="environmental-theme fade-in">
      <ModernBanner onScrollClick={scrollToSection} />
      {/* Banner Parallax - Versión mejorada */}
      {/* <div className="parallax-container">
        <div 
          className="parallax-banner"
          style={{ backgroundImage: "url('images/zula.jpeg')" }}
        >
          <div className="parallax-overlay"></div>
          <div className="parallax-content">
            <h1 className="parallax-title">Región Río Verde</h1>
            <p className="parallax-subtitle">
              Ordenamiento territorial y desarrollo sustentable
            </p>
          </div>
        </div>
      </div> */}
       
       {/* <section id="DocumentosE" className="py-16 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
          
            

         <DocumentRepository2
              items={RioVerdeMain}
              // title="Región Sierra Occidental"
              // subtitle="Programa de Ordenamiento Territorial Ecológico Regional (POETR)"
              onDownload={(doc) => window.open(doc.url, '_blank')}
              showFooter={false}
            />
            </section> */}

     {/* <AboutSection 
        title="Ordenamiento Región Río Verde"
        content={aboutContent}
        links={aboutLinks}
        dates={aboutDates}
    phase="Ejecución"
        mainDocumentLink={{
          url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/Verde/Descargas/Peri%C3%B3dico%20Oficial%20Programa%20de%20ordenamiento%20Ecol%C3%B3gico%20territorial%20regional%20cuenca%20baja%20del%20rio%20verde.pdf",
          text: "Publicación en Periódico Oficial"
        }}
       
        // mainDocumentLinkR={{
        //   url: "https://periodicooficial.jalisco.gob.mx/sites/periodicooficial.jalisco.gob.mx/files/09-11-2i-vi.pdf", 
        //   text: "Reforma de la Publicación en Periódico Oficial"
        // }}
      />  */}

       {/* Nueva sección: Municipios de la Región Costalegre */}
      {/* <section id="Descargas" className="py-16 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
     <Descargas dataItems={Items} />
     </section> */}
      {/* <Gallery imagesProp={imageList} itemsPerPage={4} /> */}
    */}
          

{/* <section className="flex flex-col md:flex-row flex-1">
    <aside className="w-full md:w-96 bg-white shadow-2xl border-r border-gray-200 p-6 flex flex-col">
          
          <div className="mb-6">
            <img
              src="/images/Clave_UGA_Cuenca_Baja_del_Río_Verde.png"
              alt="Diagrama UGAs"
              className="rounded-xl shadow-md"
            />
          </div>

          
          <div className="mb-6">
            <h2 className="text-xl font-bold text-sky-700 mb-2">
              Descripción de las UGAs
            </h2>
            <p className="text-gray-700 leading-relaxed text-justify">
              Unidad mínima del territorio a la que se asignan determinados lineamientos y estrategias ecológicas.
            </p>
          </div>
          


         
          <div>
            <h2 className="text-xl font-bold text-sky-700 mb-4">Políticas Ambientales</h2>
           <p className="text-gray-700 leading-relaxed text-justify">
              El presente Modelo de Ordenamiento Ecológico y Territorial Regional considera una zonificación, integrada por cinco políticas que buscan definir el estado deseable del territorio mediante lineamientos, estrategias y criterios para conservar y controlar el deterioro del ambiente así como el aprovechamiento sustentable de los recursos naturales.
            </p> 
          </div>
        </aside>
        
     
       
        
      <VisorSection 
        title="Visor Ordenamiento Región Río Verde"
        iframeSrc="https://siga.jalisco.gob.mx/ordenamiento/visores/visorRioVerde/index.html"
      />
      </section> */}

      
      {/* <section className="flex-1 relative bg-gray-200" id='Visor'>
<FullWidthVisorWithSidebar />
      </section> */}

      
{/* <ModernBitacoraSection items={bitacoraItems} /> */}
<section id="introduccion" className="py-16">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900 
                rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700"
            >
              <div className="flex flex-col lg:flex-row items-start gap-8">
                <div className="lg:w-2/3">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-gradient-to-r from-blue-500 to-teal-500 rounded-lg">
                      <Info className="w-5 h-5 text-white" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                      Ordenamiento Ecológico Regional
                      <span className="block text-lg text-gray-600 dark:text-gray-300 mt-1">
                        Sierra del Tigre
                      </span>
                    </h2>
                  </div>
                  
                  <div className="space-y-4 text-gray-700 dark:text-gray-300">
                    <p>
                      El <strong>Gobierno del Estado de Jalisco</strong> impulsa el desarrollo sustentable 
                      en la región denominada <strong>Sierra del Tigre</strong>, integrada por los municipios de 
                      <strong> Mazamitla, La Manzanilla de la Paz, Concepción de Buenos Aires, Valle de Juárez, Quitupan y Tamazula de Gordiano</strong>
                      , reconocida como una zona estratégica por su valor ambiental y potencial de desarrollo regional.
                    </p>
                    
                    <p>
                      Con este propósito, se estableció un esquema de coordinación entre el Estado y los municipios para la elaboración del Programa de Ordenamiento Ecológico y Territorial Regional, así como instrumentos complementarios de planeación urbana. Dicho proceso tiene como finalidad regular los usos del suelo, orientar el aprovechamiento sustentable de los recursos naturales bajo un enfoque de cuenca y atender las problemáticas socioambientales de la región.
                    </p>
                    
                    <p>
                      Este instrumento sienta las bases para una planeación integral del territorio, promoviendo el equilibrio entre el desarrollo económico, la conservación ambiental y la reducción de desigualdades, en congruencia con la política ambiental vigente.
                    </p>
                    {/* <p>
                       Es importante señalar que, si bien el municipio de Talpa de Allende no suscribió el convenio de colaboración,
                       su territorio sí fue considerado dentro del ámbito de aplicación del ordenamiento toda vez que la regionalización 
                       responde a un sistema de intervención territorial basado en similitudes económicas y territoriales, 
                       así como un enfoque de cuenca orientado a la conservación de los recursos naturales.
                    </p> 
                    <p>
                     Asimismo, se firmó con la Federación un <strong>Convenio Marco de Coordinación</strong> junto con <strong>SEMARNAT Y SEDATU</strong>
                     de fecha el 27 de enero de 2020. Estos convenios establecen los fundamentos para la colaboración en el proceso de elaboración de los siguientes instrumentos de ordenamiento territorial.
                    </p>
                    <p>
                     
                     Derivado de esto se inició con el proceso de elaboración de los instrumentos, seguido por el <strong> proceso de consulta </strong>, 
                     la cual incluyó amplia participación de los sectores que influyen en el territorio. Las fechas más relevantes sobre 
                     el proceso de elaboración se describen a continuación:
                    </p>*/}
                  </div>
                </div>
                
                {/* <div className="lg:w-1/3">
                  <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg border border-gray-100 dark:border-gray-700">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                      <ClockIcon className="w-5 h-5 text-blue-500 mr-2" />
                      Cronología Clave
                    </h3>
                    <ul className="space-y-3">
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Inicio de proceso de formulación:</strong><br /> 27 de septiembre de 2022
                        </span>
                      </li>
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Inicio de Consulta Pública:</strong><br />22 de junio de 2023
                        </span>
                      </li>
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Fin de Consulta Pública:</strong><br />22 de agosto de 2023
                        </span>
                      </li>
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Sesión de validación técnica:</strong><br />26 de enero de 2024
                        </span>
                      </li>
                      <li className="flex items-center text-sm">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3" />
                        <span className="text-gray-700 dark:text-gray-300">
                          <strong>Fecha Publicación oficial:</strong><br />28 de septiembre de 2024
                        </span>
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </motion.div>
          </div>
  
        </section>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="relative group"
          >
            {/* Card con efecto de fondo animado */}
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500 rounded-2xl blur-xl opacity-75 group-hover:opacity-100 transition-opacity duration-300" />
            
            {/* Card principal */}
            <div className="relative bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-2xl overflow-hidden">
              {/* Decoración de fondo */}
              <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-emerald-100 to-teal-100 dark:from-emerald-900/20 dark:to-teal-900/20 rounded-full -mr-20 -mt-20 opacity-50" />
              
              <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8">
                {/* Icono grande */}
                <motion.div
                  animate={{ y: [0, -10, 0] }}
                  transition={{ repeat: Infinity, duration: 3 }}
                  className="flex-shrink-0"
                >
                  <div className="p-6 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl shadow-lg">
                    <FaFilePdf className="w-16 h-16 text-white" />
                  </div>
                </motion.div>
        
                {/* Contenido */}
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-3 py-1 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 rounded-full text-xs font-semibold tracking-widest">
                      DOCUMENTO OFICIAL
                    </span>
                  </div>
                  <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 dark:text-white mb-3">
                    Informe de Diagnóstico  
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300 mb-2">
                    Estatus del Proceso de Ordenamiento Ecológico Regional
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    Cuenca Baja del Río Ayuquila - Análisis completo y recomendaciones técnicas
                  </p>
                </div>
        
                {/* Botón */}
                <motion.a
                  href="https://siga.jalisco.gob.mx/ordenamiento/archivos/Tigre/Gestion/Reporte%20Siera%20del%20Tigre.pdf"
                  download
                  whileHover={{ scale: 1.08 }}
                  whileTap={{ scale: 0.95 }}
                  className="flex-shrink-0 relative"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-emerald-500 to-teal-600 rounded-xl blur-lg opacity-75 group-hover:opacity-100 transition-all duration-300" />
                  <button className="relative px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700
                    text-white rounded-xl font-semibold flex items-center gap-2 shadow-lg hover:shadow-2xl transition-all duration-300">
                    <DownloadIcon className="w-5 h-5" />
                    <span>Descargar PDF</span>
                    <motion.div
                      animate={{ y: [0, 5, 0] }}
                      transition={{ repeat: Infinity, duration: 1.5 }}
                    >
                      <ArrowDown className="w-4 h-4" />
                    </motion.div>
                  </button>
                </motion.a>
              </div>
        
              {/* Línea decorativa inferior */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500" />
            </div>
          </motion.div>
        </div>

      <BitacoraSection 
        title="Bitácora Ambiental Río Verde"
        accordionItems={bitacoraItems2}
        accordionIcon={<FileTextIcon size={20} className="mr-3 text-sky-600" />}
      />
      <FasesSection 
        imageUrl="images/FasesOrdenamiento.png"
        altText="Fases del Ordenamiento Río Zula"
      />
     
    </div>
  );
};

export default SierradelTigre;